/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Calculator = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 13 19" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M11 1.973H2v14.981h9zm0-2.006c1.105 0 2 .898 2 2.006v14.981a2.003 2.003 0 0 1-2 2.006H2c-1.105 0-2-.898-2-2.006V1.974C0 .865.895-.033 2-.033zM9.999 3.006V5.99H3V3.006zM5.014 8.992H3.002V7.001h2.012zm0 3H3.002V10h2.012zm0 3H3.002v-1.991h2.012zm3-6H6.002V7.001h2.012zm0 3H6.002V10h2.012zm0 3H6.002v-1.991h2.012zm1.993-6H9V7.001h1.006zm0 5.999H9V10h1.006z" />
      </g>
    </svg>
  </span>
);

Calculator.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Calculator.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Calculator;
